module.exports = __webpack_public_path__ + "static/media/ToggleOnIcon.930b45b6.svg";